import { DeviceInfoSection } from "@/components/DeviceInfoSection";
import { useSEO } from "@/lib/seo/useSEO";

export const AboutUsPage: React.FC = () => {
  useSEO({
    title: "About Us - KeptScene",
    description: "Learn about KeptScene - where we cherish imperfect edges and celebrate moments that don't try too hard yet stay with you longer.",
    keywords: "KeptScene, about us, photo booth company, photo editing",
  });

  return (
    <div className="px-8 mt-12">
      <h1>About Us</h1>
      <p className="font-family-reenie mt-8">
        At KeptScene, we cherish those imperfect edges. The slightly tilted
        head, the unexpected laugh, the friend who pops into the frame at the
        wrong time — they all become the charm we keep. A quiet celebration of
        moments that don’t try too hard yet stay with you longer than the
        polished ones. At KeptScene, we cherish those imperfect edges. The
        slightly tilted head, the unexpected laugh, the friend who pops into the
        frame at the wrong time — they all become the charm we keep. A quiet
        celebration of moments that don’t try too hard yet stay with you longer
        than the polished ones.
      </p>
      <p className="text-right font-family-reenie mt-8">
        Kept scene team.
      </p>
      <DeviceInfoSection />
    </div>
  );
};
